import React, { useEffect, createElement } from 'react';
import { CheckoutPage } from './components/CheckoutPage';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (!window.fbq) {
      const n = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      window.fbq = n;
    }
    window.fbq('init', '1272995411715259');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-[#0a0a0a]" data-id="element-0">
      <CheckoutPage data-id="element-1" />
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-2">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1272995411715259&ev=PageView&noscript=1" data-id="element-3" />
      </noscript>
    </div>;
}